import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from "date-fns";

import autoTable from "jspdf-autotable";
import { AccountModel } from "../../../../../domain/models";
import {
  ProductProvider,
  PurchasesOrderItem,
  SuccessfulDSTVPurchase,
} from "../../../../../domain/usecases/get-account-balances";

export const printDSTVUnregistered = (
  transaction: PurchasesOrderItem,
  itemIdx: number,
  account: AccountModel,
  provider: ProductProvider
) => {
  console.log("transaction.dateUpdated", transaction.dateUpdated);

  const response = transaction.response as SuccessfulDSTVPurchase;

  const outletId = account.account;

  const doc = new jsPDF();

  var imgData =
    "data:image/png;base64,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";
  doc.setFontSize(40);

  doc.addImage(imgData, "PNG", 14.5, 15.5, 38.25, 5.4);

  autoTable(doc, {
    theme: "plain",
    startY: 23,
    headStyles: { fontSize: 14, fontStyle: "bold", halign: "left" },
    bodyStyles: {
      fontSize: 10,
      fontStyle: "normal",
      cellWidth: "auto",
      halign: "center",
    },
    styles: { cellPadding: 0.5 },
    columnStyles: {
      0: { halign: "left", cellWidth: 100 },
      2: { halign: "right", cellWidth: "auto" },
      3: { halign: "right", cellWidth: "auto" },
    },

    // head: [[`${provider.name}`, "", "", ""]],

    body: [[`Telephone: (267) 319 0468`, "", "", ""]],
  });
  // autoTable(doc, {
  //   // tableWidth: 100,
  //   theme: "plain",
  //   // startY: 50,
  //   headStyles: { fontSize: 14, fontStyle: "bold", halign: "left" },
  //   bodyStyles: { fontSize: 10, fontStyle: "normal", cellWidth: "auto" },
  //   styles: { cellPadding: 0.5 },
  //   columnStyles: {
  //     0: { halign: "left" },
  //     2: { halign: "left" },
  //     3: { halign: "right" },
  //   },

  //   head: [[`${provider.name}`, "", "", ""]],

  //   body: [
  //     [`${provider.postalAddress}`, "", "VAT#", `${provider.companyNumber}`],
  //     [`${provider.city}`, "", "Telephone:", `${provider.telephone}`],
  //     [
  //       `Date: ${format(new Date(transaction.dateUpdated), "yyyy-MM-dd")}`,
  //       "",
  //       "Reference:",
  //       `${response.transaction_reference}`,
  //     ],
  //   ],
  // });

  autoTable(doc, {
    theme: "plain",
    headStyles: { fontSize: 14, fontStyle: "bold", halign: "center" },
    styles: { cellPadding: 0.5 },
    startY: 43,
    tableWidth: "auto",
    head: [["", "", "PAYMENT RECEIPT", "", ""]],
    body: [["", "", "", "", ""]],
  });

  doc.line(195.5, 55, 14, 55);

  let wantedTableWidth = 82;
  let pageWidth = doc.internal.pageSize.width;
  let margin = (pageWidth - wantedTableWidth) / 2;

  autoTable(doc, {
    tableWidth: 76,
    theme: "plain",
    headStyles: { fontSize: 10, fontStyle: "bold", halign: "center" },
    bodyStyles: {
      fontSize: 10,
      fontStyle: "normal",
      halign: "center",
      cellWidth: "auto",
    },
    styles: { cellPadding: 0.5 },
    startY: 65,
    columnStyles: {
      center: { halign: "center" },
    },

    head: [["Sale  |  Credit Purchase  -  MultiChoice"]],

    body: [
      {
        center: `${format(
          new Date(transaction.dateUpdated),
          "yyyy-MM-dd HH:mm:ss"
        )}`,
      },
    ],
    margin: { left: margin, right: margin },
    columns: [{ header: "", dataKey: "center" }],
  });

  autoTable(doc, {
    tableWidth: 96,
    theme: "plain",
    headStyles: { fontSize: 10, fontStyle: "bold" },
    bodyStyles: { fontSize: 10, fontStyle: "normal", cellWidth: "wrap" },
    styles: { cellPadding: 0.5 },
    startY: 75,
    head: [["", ""]],
    body: [[`Outlet:${outletId}`]],
    margin: { left: margin, right: margin },
  });

  doc.setFontSize(10);
  doc.setTextColor(20);
  // doc.text(`Name:${response.creditVendReceipt.name}`, 64.5, 93.5);

  autoTable(doc, {
    tableWidth: 76,
    theme: "plain",
    headStyles: { fontSize: 10, fontStyle: "bold", halign: "center" },
    bodyStyles: {
      fontSize: 10,
      fontStyle: "normal",
      halign: "center",
      cellWidth: "auto",
    },
    styles: { cellPadding: 0.5 },

    columnStyles: {
      center: { halign: "left" },
    },
    startY: 86,
    head: [["Customer Details"]],
    margin: { left: margin, right: margin },
    columns: [{ header: "", dataKey: "center" }],
  });

  autoTable(doc, {
    tableWidth: 76,
    theme: "plain",
    headStyles: { fontSize: 10, fontStyle: "bold" },
    bodyStyles: { fontSize: 10, fontStyle: "normal" },
    styles: { cellPadding: 0.5 },
    startY: 88,
    head: [["", "", ""]],
    body: [
      ["Name:", "", `${response.customer_name}`],
      ["Surname", "", `${response.customer_surname}`],
      ["Cust No:", "", `${response.smartcard_number}`],
    ],
    margin: { left: margin, right: margin },
  });

  autoTable(doc, {
    tableWidth: 76,
    theme: "plain",
    headStyles: { fontSize: 10, fontStyle: "bold", halign: "center" },
    bodyStyles: {
      fontSize: 10,
      fontStyle: "normal",
      halign: "center",
      cellWidth: "auto",
    },
    styles: { cellPadding: 0.5 },

    columnStyles: {
      center: { halign: "left" },
    },
    startY: 114,
    head: [["Transaction Details"]],
    margin: { left: margin, right: margin },
    columns: [{ header: "", dataKey: "center" }],
  });

  autoTable(doc, {
    tableWidth: 76,
    theme: "plain",
    headStyles: { fontSize: 10, fontStyle: "bold" },
    bodyStyles: { fontSize: 10, fontStyle: "normal" },
    styles: { cellPadding: 0.5 },
    startY: 116,
    columnStyles: { 2: { halign: "right" } },
    head: [["", "", ""]],
    body: [
      ["Reference:", "", `${response.transaction_reference}`],
      ["Amount Paid", "", `${response.amount}`],
      ["Smart Card:", "", `${response.smartcard_number}`],
    ],
    margin: { left: margin, right: margin },
  });

  doc.line(146.5, 140, 64.5, 140);

  // doc.setFontSize(12);
  doc.text(`For queries contact Multichoice Botswana on`, 64.5, 145);
  doc.text(`WhatsApp: +267 7303 8902`, 64.5, 151.5);
  doc.text(`Call Centre Line: +267 360 5666`, 64.5, 156.5);

  doc.setTextColor(100);

  doc.save(`${transaction.itemType}-${transaction.number}.pdf`);
};
